<template>
  <th :class="{ clickable: property }" @click="headerClicked(property)">
    <div class="header-content">
      <span class="header-title">{{ title }}</span>

      <i
        v-if="sortedByProperty === property && sortAscending"
        class="icon-chevron-up"
      ></i>
      <i
        v-if="sortedByProperty === property && !sortAscending"
        class="icon-chevron-down"
      ></i>
    </div>
  </th>
</template>

<script>
export default {
  name: "TableHeader",

  props: {
    title: {
      type: String,
      required: true
    },

    // Setting this to null prevents sorting
    property: {
      type: String,
      default: null
    },

    sortedByProperty: {
      type: String,
      default: null
    },

    sortAscending: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    headerClicked(key) {
      if (!this.property) return;

      var sortedByProperty = this.sortedByProperty;
      var sortAscending = this.sortAscending;

      if (this.sortedByProperty !== key) {
        sortAscending = true;
        sortedByProperty = key;
      } else {
        sortAscending = !this.sortAscending;
      }

      this.$emit("sort-changed", {
        sortedByProperty,
        sortAscending
      });
    }
  }
};
</script>

<style lang="scss" scoped>
th {
  white-space: nowrap;

  .header-content {
    display: flex;
    align-items: center;

    .header-title {
      margin-right: 0.25em;
    }
  }
}

th.clickable {
  cursor: pointer;
}
</style>
